// Names must match the otherPaymentType enum that dashboard-bff accepts. Anything else is rejected.
export const OTHER_PAYMENT_TYPES = [
    'OptionFee',
    'AdditionalDeposit',
    'HoaFees',
    'InspectionFee',
    'SellerSettlementFees',
    'Other',
] as const;

export type OtherPaymentType = (typeof OTHER_PAYMENT_TYPES)[number];

export const OTHER_PAYMENT_TYPE_LABELS: Record<OtherPaymentType, string> = {
    OptionFee: 'Option fee',
    AdditionalDeposit: 'Additional deposit',
    HoaFees: 'HOA fees',
    InspectionFee: 'Inspection fee',
    SellerSettlementFees: 'Seller settlement fees',
    Other: 'Other',
};

export const OTHER_PURPOSE = 'Other';

export const OTHER_PAYMENT_DESCRIPTION_MAX_LENGTH = 100;

const OTHER_PAYMENT_TYPE_SET: ReadonlySet<string> = new Set<string>(OTHER_PAYMENT_TYPES);

export const isOtherPaymentType = (value: unknown): value is OtherPaymentType =>
    typeof value === 'string' && OTHER_PAYMENT_TYPE_SET.has(value);

export interface OtherPaymentSelection {
    type: OtherPaymentType;
    // Only sent for type "Other", where the participant wrote the label themselves.
    description?: string;
}

// Only type Other reads the description, since the participant wrote that label.
export const getOtherPaymentLabel = (type: unknown, description?: unknown): string => {
    if (!isOtherPaymentType(type)) return OTHER_PAYMENT_TYPE_LABELS.Other;
    if (type !== 'Other') return OTHER_PAYMENT_TYPE_LABELS[type];
    const trimmed = typeof description === 'string' ? description.trim() : '';
    return trimmed || OTHER_PAYMENT_TYPE_LABELS.Other;
};
